import EventEmitter from 'events';

export const toastEmitter = new EventEmitter();

export const showToast = (message: string, options: { appearance: string }, error?: any) => {
  if (error?.status === 500 || error?.status === 502) {
    toastEmitter.emit('show-toast', { message: 'Something went wrong!', options: { appearance: 'error' } });
  } else if (error?.status === 404) {
    toastEmitter.emit('show-toast', { message: 'Something went wrong!', options: { appearance: 'error' } });
  } else {
    toastEmitter.emit('show-toast', { message, options });
  }
};
